import { FC } from "react";
import { BomPageExplainerSection } from "../molecules";

const sections = [
  {
    title: "pq-bom-t1-product-page-instructions-modal-content-1-title",
    description: "pq-bom-t1-product-page-instructions-modal-content-1-text",
    image: "/images/pq-bom-t1/product_explainer_gif_1.gif",
  },
  {
    title: "pq-bom-t1-product-page-instructions-modal-content-2-title",
    description: "pq-bom-t1-product-page-instructions-modal-content-2-text",
    image: "/images/pq-bom-t1/product_explainer_gif_2.gif",
  },
];

export const BomPageExplainerContent: FC = () => {
  return (
    <div className="grid gap-5 overflow-y-auto">
      {sections.map((section) => (
        <BomPageExplainerSection
          key={section.title}
          title={section.title}
          description={section.description}
          image={section.image}
        />
      ))}
    </div>
  );
};
